import React from 'react';
import { connect } from 'react-redux';
import AuthComponent from './auth-component';

class AuthToggle extends AuthComponent {
    constructor(props) {
        super(props);
    }

    userIsAuthorized(user) {
        if (typeof this.props.userIsAuthorized === 'function') {
            return this.props.userIsAuthorized(user);
        } else if (typeof this.props.userIsAuthorized === 'boolean') {
            return this.props.userIsAuthorized;
        } else if (this.props.roles) {
            let roles = this.props.roles;
            if (!Array.isArray(roles)) {
                roles = [this.props.roles];
            }

            for (var i = 0; i < roles.length; i++) {
                let role = roles[i];
                if (role === user.roles) {
                    return true;
                }
            }

            return false;
        }

        return true;
    }

    authRender() {
        return (
            <span>
                { this.props.children }
            </span>
        )
    }
}

function select(state) {
    return {
        user: state.activeUser
    }
}

export default connect(select)(AuthToggle);



// WEBPACK FOOTER //
// ./web-app/components/auth-toggle.jsx